// Visit The Stimulus Handbook for more details
// https://stimulusjs.org/handbook/introduction
//
// This example controller works with specially annotated HTML like:
//
// <div data-controller="hello">
//   <h1 data-target="hello.output"></h1>
// </div>

import { Controller } from "stimulus"
import { get } from '@rails/request.js'

export default class extends Controller {

  connect() {
  }

  async showAddPurchaser(e) {
    // get HTML string from rails controller
    const { purchaseSetId } = e.currentTarget.dataset
    console.log({ purchaseSetId })
    const url = `/crush/purchase_sets/${purchaseSetId}/show_add_purchasers_modal`
    const response = await get(url)
    const body = await response.json
    console.log({ body })
    // append body.html to document.body
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = body.html;
    // Append each child of tempDiv to document.body (in case body.html has multiple nodes)
    Array.from(tempDiv.childNodes).forEach(node => document.body.appendChild(node));
  }
}
